<template>
	<div class="pageHeader-all-box">
		<div class="pageHeader-top">
			<div class="container">
				<div class="zhuzhan-header">
					<div class="contact-box">
						<el-row type="flex" justify="space-between">
							<div class="header-top-left">
								<span class="service-text">24小时服务热线：</span>
								<strong class="red">400-678-6622</strong>
								<!-- 按当前需求隐藏“写信给我们”入口，保留结构注释便于后续恢复。 -->
								<!-- <a class="contact-list ml10" href="https://diy.yiqifei.com/addsimpleorder.aspx"
									title="写信给我们" target="_blank">
									<img src="https://tools.yiqifei.com/images/xinfeng.gif" class="i-middle" />
									<em class="i-middle">写信给我们</em>
								</a> -->
								<el-dropdown class="ml10">
									<span class="el-dropdown-link"><img
											src="//tools.yiqifei.com/images/weixin_s.gif" /></span>
									<el-dropdown-menu slot="dropdown">
										<div class="weixinbox"><img src="//tools.yiqifei.com/images/weixin.jpg"
												alt="" /></div>
									</el-dropdown-menu>
								</el-dropdown>
								<div class="loginstate" v-if="AccountInfo==null">
									<a href="javascript:;" class="header-action-link" @click="bindGetLogin">登录</a>
									&nbsp;
									<!-- /&nbsp;<a href="javascript:;" @click="bindRegister">注册</a> -->
								</div>
							</div>
							<div class="header-top-right">
								<template v-if="AccountInfo!=null">
									<el-dropdown class="account-dropdown" @command="handleCommand">
										<span class="el-dropdown-link account-trigger">
											<span class="account-trigger__label">我的帐户</span>
											<span class="iconfont icon-xiala account-trigger__icon"></span>
										</span>
										<el-dropdown-menu slot="dropdown">
											<!-- 下拉菜单补充更多常用入口，减少用户重复跳转。 -->
											<el-dropdown-item command="/member?section=profile">帐户首页
											</el-dropdown-item>
											<el-dropdown-item command="/member?section=orders">我的订单
											</el-dropdown-item>
											<el-dropdown-item command="/member?section=passengers">常旅客
											</el-dropdown-item>
											<!-- 退出当前账号走本地清理逻辑，立即刷新头部登录态。 -->
											<el-dropdown-item divided command="logout">退出当前账号
											</el-dropdown-item>
											<!-- <el-dropdown-item
												command="https://accounts.yiqifei.com/Account/MyIntergral">我的积分
											</el-dropdown-item> -->
											<!-- <el-dropdown-item command="https://accounts.yiqifei.com/">我的空间
											</el-dropdown-item> -->
										</el-dropdown-menu>
									</el-dropdown>
								</template>
								<!-- <span class="ml10" @click="bindJifenJiangli">积分奖励</span> -->
								<!-- <span class="ml10">员工家园</span> -->
								<!-- <span class="link">繁體版(港幣價)</span> -->
							</div>
						</el-row>
					</div>
				</div>
			</div>
		</div>
		<div class="pageHeader-middle container clearfix">
			<el-row type="flex" justify="space-between">
				<el-row type="flex">
					<div class="logobox">
						<a href="http://www.yiqifei.com/" class="logoimg">
							<!-- <img src="//tools.yiqifei.com/images/logo.gif"
								title="一起飞国际机票网：为您提供全球300多家航空公司往返约192个国家、4088个城市的特价机票" /> -->
							<img src="https://img0.yiqifei.com/p/6628c19c85a00912bc6ea8a0/pclogo2025.png"
								title="一起飞国际机票网：为您提供全球300多家航空公司往返约192个国家、4088个城市的特价机票" />
						</a>
					</div>
					<!-- <div class="actbox" style="padding:10px 0px 0px 10px;"><img src="../assets/tunian.png"
							style="height:70px;width: 180px;" /></div> -->

				</el-row>
				<div class="activebox">
					<el-row type="flex" align="middle">
						<div class="actbox mt10" style="margin-top: 0px;">
							<a target="_blank" href="http://ab.yiqifei.com/news/newlist.html" style="margin-right:10px;">
								<!-- <div>慎防机票预订欺诈行为</div>
								<div>认准一起飞®官方渠道</div> -->
								<img width="250px" height="86px"  src="https://www.yiqifei.com/Content/images/47afbbea9fafb56d65759c64f90578a8.png"
									title="慎防机票预订欺诈行为、认准一起飞®官方渠道" />
							</a>
						</div>
						<iframe class="active-frame" marginwidth="0" marginheight="0" frameborder="0"
							src="//tools.yiqifei.com/transfer/titlead.aspx?adcode=19" allowtransparency="true"
							scrolling="no"></iframe>
					</el-row>
				</div>
			</el-row>
		</div>
		<div class="pageHeader-bottom">
			<div class="int-nav-header">
				<el-row class="int-nav container" type="flex">
					<a href="javascript:;" @click="bindLink(item.link)" v-for="(item, index) in headNavs" :key="index"
						:to="item.link" :class="item.link == path ? 'current' : ''">
						{{ item.name }}
					</a>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
	var util = require('@/utils/util.js');
	import {
		getAccountInfo,
		setAccountInfo,
		clearLoginInfo
	} from '@/utils/localdatas';
	import {
		GetHeadNav,
		GetMessageList,
		GetNotice
	} from '@/api/memberApi';

	import Vuex from 'vuex';

	var that;
	var webconfig = require('@/utils/webconfig.js');

	export default {
		name: 'Header',
		props: {
			msg: String,
			inputValue: {
				type: [String, Number],
				default: ''
			}
		},
		setup(props) {
			console.log(props.inputValue);
		},
		watch: {
			'$store.state.routerName': {
				handler(val) {
					// 跟随 store 的路由名变化（如果有设置）
					this.path = val || this.$route.path;
				},
				immediate: true
			},
			'$route.path': {
				handler(val) {
					// 路由变化时同时刷新导航高亮和登录态，避免 header 组件复用后状态不更新。
					this.path = val;
					this.syncAccountInfo();
				},
				immediate: true
			},
			'$route.query': {
				handler() {
					// 登录成功回跳通常会带 query 变化，这里再次兜底同步一次账号信息。
					this.syncAccountInfo();
				},
				deep: true
			}
		},
		data() {
			return {
				returnurl: '/',
				path: '',
				headNavs: [{
						name: '首页',
						link: '/'
					},
					{
						name: '机票',
						link: '/Flight'
					},
					// { name: '国内机票', link: '/DomesticAir' },
					{
						name: '全球酒店',
						link: '/Hotel'
					},
					{
						name: '欧洲火车',
						link: 'http://tour.yiqifei.com/Europe'
						// link: '/Europe'
					},
					{
						name: '签证',
						// link:'http://tour.yiqifei.com/Visa'
						link: '/Visa'
					},
					// {
					// 	name: '保险',
					// 	link: '/Insurance'
					// },
					{
						name: '差旅宝',
						link: 'https://biz.yiqifei.com'
					},
					{
						name: '支付中心',
						link: 'https://pay.yiqifei.com'
					},
					{
						name: '关于我们',
						link: 'http://ab.yiqifei.com'
					}
				],
				noticeCount: '',
				NoticeText: '',
				AccountInfo: null
			};
		},
		created(props) {
			//生命周期里接收参数
			that = this;
			that.path = that.$route.path;
			console.log(that.path);
			// 首次进入页面时读取一次本地登录信息。
			that.syncAccountInfo();
			console.log(that.AccountInfo);
			// console.log('1111' + that.$route.path);
		},
		methods: {
			syncAccountInfo() {
				// 统一从 sessionStorage 读取最新账号信息，确保登录/退出后头部立即刷新。
				this.AccountInfo = getAccountInfo();
			},
			handleCommand(command) {
				// 特殊命令单独处理，避免和普通跳转混在一起。
				if (command === 'logout') {
					this.logout();
					return;
				}

				let path = command;

				if (path.indexOf('http') != -1) {
					window.location.href = path;
					return;
				}

				// 下拉项可能带 query，需要拆开后再交给路由，确保 section 参数生效。
				const pathQueryParts = path.split('?');
				const routePath = pathQueryParts[0];
				const routeQuery = this.parseRouteQuery(pathQueryParts[1]);
				that.path = routePath;
				that.$router.push({
					path: routePath,
					query: routeQuery
				});
			},
			parseRouteQuery(queryString) {
				// 把 a=1&b=2 转成对象，兼容菜单里的 query 参数。
				if (!queryString) {
					return {};
				}

				return queryString.split('&').reduce((result, item) => {
					if (!item) {
						return result;
					}

					const pair = item.split('=');
					const key = pair[0];
					const value = pair.length > 1 ? pair.slice(1).join('=') : '';

					if (key) {
						result[decodeURIComponent(key)] = decodeURIComponent(value);
					}

					return result;
				}, {});
			},
			bindJifenJiangli: function(e) {
				window.location.href = "http://gift.yiqifei.com/";
			},
			bindLink: function(e) {
				console.log(e);
				let path = e;

				if (path.indexOf('http') != -1) {
					window.location.href = path;
				} else {
					that.path = path;
					that.$router.push({
						path: path
					});
				}
			},
			bindNoticeCenter(e) {
				that.$router.push({
					path: '/Profile/NoticeCenter'
				});
			},
			logout(e) {
				console.log(that.$route.path);
				// 清空当前账号信息，让头部和页面权限立即回到未登录状态。
				clearLoginInfo();
				// 先直接置空组件状态，保证当前帧就切回未登录 UI。
				that.AccountInfo = null;
				that.syncAccountInfo();

				// 退出后统一回到登录页，避免会员中心继续展示当前页缓存的数据。
				var returnurl = encodeURIComponent(window.location.href);
				util.getLogin(returnurl);
			},
			logo() {
				console.log(1111);
				console.log(that.$route);
				var path = that.$route.path;
				that.path = this.$store.state.routerName;
				console.log(that.path + '44444');
				console.log(this.$store.state.routerName);
			},
			//登录
			bindGetLogin: function(e) {
				console.log(that.$route.path);
				// var returnurl = that.$route.path;
				var returnurl = encodeURIComponent(window.location.href);
				// var loginurl=webconfig.yqfComApiurl+'/Account/JumpLogin?returnurl='+returnurl;
				// window.location.href=loginurl;
				util.getLogin(returnurl);
			},
			//注册
			bindRegister: function(e) {
				var returnurl = that.$route.path;

			}
		}
	};

	function getHeadNav(accountno) {
		GetHeadNav(null, function(result) {
			if (result.code == 0) {
				that.headNavs = result.data.headNavs;
			}
		});
	}

	function getMessageList(accountno) {
		let parm = {
			accountno: accountno
			// accountno: 'CMC0K38F',
			// pageindex:that.pageindex
		};
		GetMessageList(parm, function(result) {
			if (result.code == 0) {
				that.noticeCount = result.data.pageCount;
				if (that.noticeCount > 99) {
					that.noticeCount = '99+';
				}
			}
		});
	}

	function getNotice(accountno) {
		GetNotice(null, function(result) {
			if (result.code == 0) {
				that.NoticeText = result.data.NoticeText;
			}
		});
	}
</script>

<!-- 头部右上角采用局部样式精修，避免影响站内其他页面。 -->
<style scoped lang="scss">
.contact-box {
	/* 顶部信息条统一垂直居中，修复字体和下拉箭头不在一条基线的问题。 */
	::v-deep .el-row {
		align-items: center;
		min-height: 30px;
	}
}

.header-top-left,
.header-top-right {
	/* 左右两组内容都走 flex 对齐，避免图片、文字、下拉混排时发生漂移。 */
	display: flex;
	align-items: center;
}

.header-top-right {
	justify-content: flex-end;
}

.service-text {
	/* 服务热线文案单独校准字号和行高，让数字看起来更平衡。 */
	display: inline-flex;
	align-items: center;
	font-size: 12px;
	line-height: 1;
	color: #606266;
}

.contact-list {
	/* 联系入口做成轻量链接样式，图标与文字保持居中。 */
	display: inline-flex;
	align-items: center;
	height: 24px;
	color: #606266;
	text-decoration: none;
	transition: color 0.2s ease;

	em {
		font-style: normal;
	}

	&:hover {
		color: #d73b3e;
	}
}

.loginstate {
	/* 登录入口与账户入口统一成胶囊按钮风格。 */
	display: inline-flex;
	align-items: center;
	margin-left: 12px;
}

.header-action-link {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	height: 28px;
	padding: 0 12px;
	border: 1px solid rgba(228, 58, 61, 0.18);
	border-radius: 14px;
	background: rgba(228, 58, 61, 0.06);
	color: #d73b3e;
	font-size: 12px;
	font-weight: 600;
	line-height: 1;
	text-decoration: none;
	transition: all 0.2s ease;

	&:hover {
		background: rgba(228, 58, 61, 0.1);
		border-color: rgba(228, 58, 61, 0.28);
		box-shadow: 0 4px 10px rgba(228, 58, 61, 0.1);
	}
}

.account-dropdown {
	/* 下拉入口使用固定高度，保证字体和箭头始终共线。 */
	display: inline-flex;
	align-items: center;
}

.account-trigger {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	height: 28px;
	padding: 0 12px;
	border: 1px solid #e5e7eb;
	border-radius: 14px;
	background: #fff;
	color: #4b5563;
	font-size: 12px;
	font-weight: 600;
	line-height: 1;
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		color: #d73b3e;
		border-color: rgba(228, 58, 61, 0.25);
		box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);
	}
}

.account-trigger__label {
	/* 文字单独限制行高，避免中文在不同浏览器里轻微下沉。 */
	display: inline-flex;
	align-items: center;
	line-height: 1;
}

.account-trigger__icon {
	margin-left: 6px;
	font-size: 12px;
	line-height: 1;
	transform: translateY(1px);
}

/* 覆盖 Element 默认触发器样式，防止获得焦点时出现难看的蓝边。 */
::v-deep .el-dropdown-selfdefine:focus,
::v-deep .el-dropdown-selfdefine:focus:active {
	outline: none;
}
</style>
